export default "__VITE_ASSET__822f13b6__"